<template>
    <div>
    <!-- Notification options -->
    <navbar-section
    id="notifListItem"
    :iconTour="'notifBtn'"
    icon="mdi-bell"
    tooltip="Notificaciones"
    >
    <card-popup :viewMoreLink="false" :items="notificationsItemList">
        <template #item="{ item, idx }">
          <v-list-item :to="item.to">
              <v-list-item-action>
              <v-icon color="primary" size="36">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
          <v-divider :key="`${idx}-divider`" />
        </template>
    </card-popup>
    </navbar-section>

    <ModalDialog
    v-if="showNews"
    :loading="loading"
    :dialog="newsDialog && welcomeNews.length > 0"
    @input="updateModalState"
    >
    <template slot="title">
        {{ $t('components.news.title') }}
      </template>

    <template slot="body">
        <v-carousel
          v-model="carouselModel"
          :continuous="false"
          :show-arrows="false"
          :light="true"
          hide-delimiter-background
          :hide-delimiters="$vuetify.breakpoint.mdAndUp"
          height="100%"
          >
          <v-carousel-item
              v-for="(newsItem, i) in welcomeNews"
              :key="newsItem.id"
              :class="['scrollable', {
              'carousel-item-padded': !$vuetify.breakpoint.mdAndUp,
              }]"
          >
              <div class="title font-weight-light text-h5 break-word pt-5 titleShare" >
                <span class="shareSpan">{{ newsItem.name }}</span>
                <v-btn
                  width="24"
                  height="24"
                  class="mr-2 shareBtn"
                  icon
                  @click.prevent="$event => share($event, welcomeNews[i])"
                >
                  <v-icon color="primary">mdi-share-variant</v-icon>
                </v-btn>
                <div v-if="openDialog" class="menuDiv">
                  <!--  -->
                  <div class="text-center">
                    <v-menu
                      v-if="$vuetify.breakpoint.mdAndUp"
                      ref="popover"
                      :value="openDialog"
                      @input="$emit('input', $event)"
                      :close-on-click="false"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x
                      :position-x="sharedDialogPosition.positionX"
                      :position-y="sharedDialogPosition.positionY"
                    >
                      <v-list class="pr-9" style="position: relative;">
                        <v-btn
                          class="btnClosed"
                          icon
                          @click="()=>closedMenu()"
                        >
                        <!-- @click.stop="$emit('input', false)" -->
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <template v-for="(action, idx) in shareActions">
                          <component
                            :is="action"
                            :item="sharedItem"
                            :key="idx"
                            @input="actionDone($event)" />
                        </template>
                      </v-list>
                    </v-menu>

                    <v-bottom-sheet
                      v-else
                      :value="openDialog"
                      @input="$emit('input', $event)"
                      inset
                      :width="$vuetify.breakpoint.smAndDown ? '100%' : '400'"
                    >
                      <v-sheet
                        class="text-center"
                        rounded
                      >
                        <v-btn
                          class="mt-2"
                          text
                          @click="$emit('input', false)"
                        >
                          {{ $t('components.share.title') }}
                        </v-btn>

                        <v-list class="px-4">
                          <template v-for="(action, idx) in shareActions">
                            <component
                            :is="action"
                            :item="sharedItem"
                            :key="idx"
                            @input="actionDone($event)" />
                          </template>
                        </v-list>
                      </v-sheet>
                    </v-bottom-sheet>

                    <v-snackbar
                      v-model="snackbar"
                      :timeout="3000"
                      top
                      class="text-center"
                    >
                      {{ snackbarMessage }}
                    </v-snackbar>
                  </div>
                </div>
              </div>

              <v-skeleton-loader
              v-if="newsDialog && loading"
              class="mt-5"
              height="100"
              type="paragraph"
              >
              </v-skeleton-loader>

              <div
              class="text-body-1 mt-5"
              v-if="!loading && !newsItem.resolution && newsItem.zinfo_usuariofinal"
              v-html="parseResolution(newsItem.zinfo_usuariofinal, newsItem.id)">
              </div>

              <div
              class="text-body-2 mt-5"
              v-if="!loading && newsItem.resolution"
              v-html="parseResolution(newsItem.resolution, newsItem.id)"
              ></div>
          </v-carousel-item>
        </v-carousel>
    </template>

    <template slot="actions" v-if="$vuetify.breakpoint.mdAndUp">
      <div v-if="showPagination">
      <v-btn
          :disabled="carouselModel === 0"
          color="primary"
          text
          @click.stop="carouselModel --"
      >
          {{ $t('commons.previous') }}
      </v-btn>
      <span class="text-body-2">
          {{ $t('commons.pageOf', [(carouselModel + 1), welcomeNews.length]) }}
      </span>
      <v-btn
          :disabled="carouselModel === (welcomeNews.length - 1)"
          color="primary"
          text
          @click.stop="carouselModel ++"
      >
          {{ $t('commons.next') }}
      </v-btn>
      </div>

      <RateComponent
      :negativeComment=false
      :pregunta="$t('views.knowledgeItems.rate.rateTitle')"
      :id="this.newsId"
      codigo="KD"
      canal=1
      />

      <v-spacer />

      <v-switch
      v-if="showSwitch"
      v-model="displayWelcomeNewsModel"
      :label="$t('components.news.switch')"
      @click="changeValueSwitch()"
      ></v-switch>

    </template>

    </ModalDialog>

</div>
  </template>

<script>
import CardPopup from '@/components/CardPopup.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import ShareActions from '@/components/share-actions';
import RateComponent from '@/components/RateComponent.vue';
import ContextGetter from '@/router/context-getter';
import { STATUS as NEWS_STATUS } from '@/store/modules/news';
import { mapGetters, mapState } from 'vuex';
import ModalDialog from './ModalDialog.vue';

export default {
  props: {
    displayWelcomeNews: Boolean,
    displayDialog: Boolean,
    showNews: Boolean,
  },
  components: {
    ModalDialog,
    NavbarSection,
    CardPopup,
    RateComponent,
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
    }),
    ...mapState({
      loading: ({ news: { status } }) => status === NEWS_STATUS.LOADING,
      news: ({ news: { news } }) => news,
      welcomeNews: ({ news: { welcomeNews } }) => welcomeNews,
      user: ({ session }) => session.session.user,
    }),
    notificationsItemList() {
      return [
        {
          name: this.$t('navbar.myNotifications'),
          icon: 'icon-ayudadigital-inbox',
          to: '/notifs',
          visibility: true,
        },
        {
          name: this.$t('navbar.subscribe'),
          icon: 'icon-ayudadigital-switch',
          to: '/configuration',
          visibility: true,
        },
      ];
    },
    shareActions() {
      return this.types
        .filter((type) => ShareActions[type] != null)
        .map((type) => ShareActions[type]);
    },
  },
  data({ displayWelcomeNews }) {
    return {
      newsDialog: false,
      carouselModel: 0,
      displayWelcomeNewsModel: !displayWelcomeNews || false,
      showSwitch: false,
      showPagination: false,
      sharedItem: null,
      sharedDialogPosition: {},
      openDialog: false,
      pathname: null,
      types: ['clipboard', 'mail'],
      snackbar: false,
      snackbarMessage: null,
      newsId: null,
    };
  },
  async created() {
    const id = parseInt(this.$getConst('news.idNews'), 10);
    await this.$store.dispatch('news/load', id);
    const publicada = this.news.findIndex((newItem) => newItem.statusId === 70);
    this.newsId = this.news[publicada].id;
    if (this.displayWelcomeNews && publicada >= 0) {
      this.viewDetails(publicada);
      this.showSwitch = true;
    } else if (this.displayWelcomeNews && publicada < 0) {
      this.updateModalState(false);
    } else {
      this.showSwitch = false;
      this.showPagination = true;
    }
    const phoneNumber = this.user.mobilePhone;
    if (phoneNumber !== undefined && phoneNumber !== null && phoneNumber !== '') {
      this.types.push('mobile');
    }
    if (this.user.isWhatsappAllowed === '201') {
      this.types.push('whatsapp');
    }
  },
  watch: {
    carouselModel(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.viewDetails(newVal);
      }
      return newVal;
    },
  },
  methods: {
    actionDone(data = {}) {
      this.$emit('input', false); // emit false to close actions dialog
      if (typeof data.snackbar === 'string') { // optionally an action could send a snackbar message to display smt
        this.snackbarMessage = data.snackbar;
        this.snackbar = true;
      }
    },
    share(evt, item) {
      evt.preventDefault();

      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;

      const knowledgeUrl = item?.zVisibleInternet === 1 || item?.zVisibleInternet === null ? 'public/news/' : 'news/';
      const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}${knowledgeUrl}${item.id}`;
      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          name: this.$t('components.share.mobile.noticeItem'),
          url: fullShareUrl,
          formName: item.name,
          type: 'NEWS',
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        this.openDialog = true;
        this.$forceUpdate();
        this.sharedItem = {
          text: `${this.$t('components.share.subjectBody.notice')} ${item.name}`,
          url: fullShareUrl,
          formName: item.name,
          type: 'NEWS',
        };

        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    viewDetails(index) {
      if (this.carouselModel !== index) {
        this.carouselModel = index;
      } else {
        if (this.loading) {
          this.$store.dispatch('news/cancel');
        }
        const newsItem = this.news[index];
        if (!this.$store.getters['news/hasDetail'](newsItem.id)) {
          this.$store.dispatch('news/detail', newsItem.id);
        }
        this.newsDialog = true;
      }
    },
    changeValueSwitch() {
      this.$store.dispatch('globalState/setRemoteItem', { key: 'display_welcome_news', value: !this.displayWelcomeNewsModel });
    },
    parseResolution(resolution, KiId) {
      const accessKey = (this.$store.getters['session/storage'] || {}).access_key;
      if (typeof resolution !== 'string' || accessKey == null) {
        return resolution;
      }
      return resolution.replace(/<img[^>]*src=["']([^"']+)["'][^>]*>/g, (img, src) => {
        // Si contiene linkexternal="true", no modificar
        if (/\blinkexternal=["']true["']/.test(img)) {
          return img;
        }

        const NUMERIC_REGEXP = /[-]?\d*\.?\d+/g;
        const numbers = src.match(NUMERIC_REGEXP);

        if (!numbers || !numbers[1]) {
          return img;
        }

        const apiClientBaseUrl = (process.env.NODE_ENV === 'development'
          ? '/'
          : ContextGetter.getContext()) + process.env.VUE_APP_BASE_REST_URL;

        const urlImage = `${apiClientBaseUrl}/knowledge-item/${KiId}/attachment/${numbers[1]}?accessKey=${accessKey}`;

        return img.replace(src, urlImage);
      });
    },
    updateModalState($event) {
      if ($event) {
        this.newsDialog = $event;
      } else {
        this.newsDialog = $event;
        const videos2 = document.querySelectorAll('video');
        videos2.forEach((video) => {
          video.pause();
        });
        const iframes = document.querySelectorAll('iframe');
        iframes.forEach((iframe) => {
          iframe.remove();
        });
      }
      setTimeout(() => {
        this.showSwitch = false;
        this.showPagination = true;
      }, 400);
      this.$emit(`newsmodal:${$event ? 'open' : 'close'}`);
    },
    closedMenu() {
      this.openDialog = false;
    },
  },
};
</script>

  <style lang="scss" scoped>
    /* check: https://vuetifyjs.com/en/components/carousels/ -> API -> SASS */
    $carousel-controls-size: 50px !default;

    .carousel-item-padded {
      padding-bottom: $carousel-controls-size;
    }

    .break-word {
      white-space: break-word;
    }
  </style>

  <style lang="scss">
    .v-carousel .scrollable .v-responsive__content {
      margin-top: 5px;
      overflow: auto;
      max-height: 100%;
    }
    .shareDiaglogPopUp{
      /*float: inline-start;
      position: static !important;*/
      z-index: 1000 !important;
      min-width: 100% !important;
      min-height: 100% !important;
    }
    .shareDiv{
      position: absolute;
      z-index: 1000 !important;
      min-width: 100% !important;
      min-height: 100% !important;
    }
    .titleShare{
      display: flex !important;
      position: relative;
    }
    .shareSpan{
      width: calc(100% - 40px) !important;
      overflow: hidden;
    }
    .shareBtn{
      background-color: white;
      padding-left: 3px !important;
    }
    .menuDiv{
      position: absolute;
    }
    .btnClosed{
      position: absolute;
      top: 10px;
      right: 10px;
    }
  </style>
